import { LegislationKey } from '@core/domain/legislation'

const normalizeId = value => (
    value === null || typeof value === 'undefined' ? null : String(value)
)

const getSubstanceListId = legislation => {
    if (!legislation) {
        return null
    }

    return legislation.substanceListId
        || (legislation.substanceList && legislation.substanceList.id)
        || null
}

const isReachLegislation = legislation => (
    legislation
    && String(legislation.key || '').toLowerCase() === String(LegislationKey.REACH).toLowerCase()
)

const containerBelongsToList = (container, listId) => {
    const normalizedListId = normalizeId(listId)

    return normalizedListId !== null
        && Array.isArray(container && container.lists)
        && container.lists.some(list => normalizeId(
            list && typeof list === 'object' ? list.id : list,
        ) === normalizedListId)
}

const getSelectedSubstanceContainers = context => [
    ...(context.includedSubstances || []),
    ...(context.componentConcernSubstances || []).reduce((containers, component) => (
        containers.concat(component && Array.isArray(component.substances) ? component.substances : [])
    ), []),
]

const getReachCandidateListId = context => {
    const reach = ((context.request && context.request.legislations) || []).find(isReachLegislation)

    return getSubstanceListId(reach)
}

const isScipApplicable = context => {
    const candidateListId = getReachCandidateListId(context)

    return candidateListId !== null
        && getSelectedSubstanceContainers(context)
            .some(container => containerBelongsToList(container, candidateListId))
}

export {
    getReachCandidateListId,
    getSelectedSubstanceContainers,
    getSubstanceListId,
    isScipApplicable,
}
